import React, { FunctionComponent } from "react";
import { Page } from "@react-pdf/renderer";

// the Main Content needs to ignore the fixed header/footer, that's why the padding is more than the padding of the fixed + content space
const DocumentBody: FunctionComponent<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Page
    orientation="portrait"
    style={{
      paddingBottom: "110px",
      paddingTop: "72px",
      paddingHorizontal: "55px",
      position: "relative",
    }}
  >
    {children}
  </Page>
);

export default DocumentBody;
